import * as angular from 'angular';
import * as _ from 'lodash';
import {Plant} from "../../models/navigation";
import {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import EquipmentServiceName, {EquipmentService} from "../../services/equipment/equipment.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {ConfigController, EquipmentDataPoint} from "./config.base";
import {apsCommands} from "../../shared/dto/aps.commands";
import {PlantLocation} from "../../services/locations/locations.service";
import template from './addEquipment.tpl.html';
import DataPointsSelector from './dataPointsSelector.directive';
import ConfigSelector from './configSelector.directive';

let requires = [EquipmentServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName, DataPointsSelector,
  ConfigSelector];

interface AddEquipmentController extends ConfigController {
  plant: Plant;
  typeChanged(): void;
  types: EnumOption[];
  add(): void;
  cancel(): void;
  ipAddressPattern: RegExp;
}

export interface AddEquipmentParams {
  plant: Plant;
  locations: PlantLocation[];
  isNotProd: boolean;
  allEquipment: apsViewModels.EquipmentDetail[];
  ipAddressPattern: RegExp;
}

export function openAddEquipment(data: AddEquipmentParams,
                                 $modal: mm.foundation.modal): angular.IPromise<apsViewModels.EquipmentDetail> {
  return $modal.open({
    template: template,
    controller: 'AddEquipmentCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class AddEquipmentCtrl implements AddEquipmentController {
  plant: Plant;
  locations: PlantLocation[];
  instance: apsViewModels.EquipmentDetail;
  config: any;
  location: PlantLocation;
  types: EnumOption[];
  form: angular.IFormController;
  dataPoints: EquipmentDataPoint[];
  isNotProd: boolean;
  allEquipment: apsViewModels.EquipmentDetail[];
  ipAddressPattern: RegExp;

  private allLocations: PlantLocation[];
  private equipmentService: EquipmentService;
  private $modalInstance: mm.foundation.modalInstance;
  private notifyService: NotifyService;
  private loaderService: LoaderService;

  constructor(
    data: AddEquipmentParams,
    newGuidService: NewGuidService,
    equipmentService: EquipmentService,
    $modalInstance: mm.foundation.modalInstance,
    notifyService: NotifyService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService
  ) {
    this.equipmentService = equipmentService;
    this.$modalInstance = $modalInstance;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.plant = data.plant;
    this.allLocations = data.locations;
    this.config = {};
    this.instance = <apsViewModels.EquipmentDetail>{
      isSimulator: false,
      active: false
    };
    this.dataPoints = [];
    this.isNotProd = data.isNotProd;
    this.allEquipment = data.allEquipment;
    this.ipAddressPattern = data.ipAddressPattern;

    newGuidService.getNewGuid('equipment').then(id => this.instance.id = id);
    this.types = _.sortBy(uiUtilityService.getListOptionsFromEnum(apsEnums.EquipmentType, 1), x => x.text);
    this.filterLocations();
  }

  private filterLocations() {
    let locationTypes = this.equipmentService.getValidLocationTypes(this.instance.type);
    if (locationTypes.length === 0) {
      this.locations = [];
      return;
    }

    this.locations = _.filter(this.allLocations, l =>
      _.some(locationTypes, lt => l.locationType === lt));
  }

  typeChanged(): void {
    this.filterLocations();
    if (this.location) {
      if (!_.some(this.locations, l => l.id === this.location.id)) {
        this.location = null;
      }
    }
  }

  add(): void {
    if (this.form.$invalid) {
      return;
    }

    _.forEach(this.dataPoints, (dp: EquipmentDataPoint) => {
      dp.config = JSON.stringify(dp.jsonConfig);
    });

    let command: apsCommands.AddEquipment = {
      id: this.instance.id,
      plantId: this.plant.id,
      config: JSON.stringify(this.config),
      type: this.instance.type,
      active: this.instance.active,
      isSimulator: this.instance.isSimulator,
      plantLocationId: this.location.location.id,
      name: this.instance.name,
      dataPoints: JSON.parse(JSON.stringify(this.dataPoints))
    };

    _.forEach(command.dataPoints, (dp: any) => {
      dp.jsonConfig = undefined;
    });

    this.loaderService.loadingPromise(this.equipmentService.add(command)
      .then(() => {
        this.instance.config = command.config;
        this.instance.plantLocationId = command.plantLocationId;
        this.instance.plantLocationLocationType = this.location.locationType;
        this.instance.plantLocationLocationTypeId = this.location.id;
        if (this.location.locationType === apsEnums.LocationType.Plant) {
          this.instance.plantLocationName = this.plant.name;
        } else {
          this.instance.plantLocationName = this.location.name;
        }
        this.instance.plantLocationPlantId = this.plant.id;
        this.instance.dataPoints = <apsViewModels.DataPointDetail[]>command.dataPoints;
        _.forEach(this.instance.dataPoints, (dp: apsViewModels.DataPointDetail) => {
          dp.plantId = this.plant.id;
        });
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.addEquipment', requires)
  .controller('AddEquipmentCtrl', AddEquipmentCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/equipment/addEquipment.controller.ts